import { queryBuilder } from '@lbs/swarm-client';

import { GameTypeEnum } from '@common/constants/enums/gameType';

export const getSwarmPromotedGamesCountQuery = () => (
  queryBuilder()
    .useSource('betting')
    .selectGame('@count')
    .whereGame('promoted')
    .is(true)
    .getParams()
);

export const getSwarmPopuplarPromotedGamesQuery = () => {
  const builder = queryBuilder()
    .useSource('betting')
    .selectGame(['id', 'is_blocked', 'team1_name', 'team2_name', 'sport_alias', 'region_alias', 'type', 'game_number', 'start_ts', 'info', '#competition:id', '#competition:name'])
    .selectMarket(['id', 'type', 'display_key', 'order'])
    .selectEvent(['id', 'name', 'price', 'order'])
    .whereGame('promoted')
    .is(true)
    .whereMarket('type')
    .in(['P1P2', 'P1XP2'])
    .whereEvent('type')
    .in(['P1', 'X', 'P2']);

  return builder.getParams();
};

export const getSwarmPopuplarLiveGamesQuery = (gameCount, showStats = true) => {
  const gameKeys = ['id', 'is_blocked', 'team1_name', 'team2_name', 'sport_alias', 'region_alias', 'type', 'game_number', 'info', '#competition:id', '#competition:name']

  if (showStats) {
    gameKeys.push('stats');
  }

  const builder = queryBuilder()
    .useSource('betting')
    .selectMarket(['id', 'type', 'display_key', 'order'])
    .selectGame(gameKeys)
    .selectEvent(['id', 'name', 'price', 'order'])
    .whereGame('type')
    .is(GameTypeEnum.Live)
    .is(true)
    .whereGame('@limit')
    .is(gameCount)
    .whereMarket('type')
    .in(['P1P2', 'P1XP2'])
    .whereEvent('type')
    .in(['P1', 'X', 'P2']);

  return builder.getParams();
};